document.addEventListener('DOMContentLoaded', () => {
  const DELAY_STEP = 400;

  const createObserver = (callback, options = {}) =>
    new IntersectionObserver(callback, { threshold: 0.4, ...options });

  const standaloneEls = document.querySelectorAll(
    '.animate__animated:not(.js-scene .animate__animated)'
  );

  const standaloneObserver = createObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const effect = entry.target.dataset.animation ?? 'animate__fadeIn';
        entry.target.classList.add(effect);
        standaloneObserver.unobserve(entry.target);
      }
    });
  });

  standaloneEls.forEach((el) => standaloneObserver.observe(el));

  const scenes = document.querySelectorAll('.js-scene');

  const sceneObserver = createObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const els = entry.target.querySelectorAll('.animate__animated');

        els.forEach((el) => {
          const time = parseInt(el.dataset.time ?? 1);
          const delay = (time - 1) * DELAY_STEP;

          setTimeout(() => {
            const effect = el.dataset.animation ?? 'animate__fadeIn';
            el.classList.add(effect);
          }, delay);
        });

        sceneObserver.unobserve(entry.target);
      }
    });
  });

  scenes.forEach((scene) => sceneObserver.observe(scene));
});
